import React from 'react';
import {Container} from 'reactstrap';
import logoCCOS from '../../assets/images/ccos-logo-removebg-preview.png';

const TopBarSimple = () => {
  return (
    <header id="topnav" className="defaultscroll sticky" style={{backgroundColor: 'white'}} >
      <Container>
        <div className="m-3" style={{alignItems: 'flex-start'}}>
          <img src={'https://local-apl-bills.s3.us-east-2.amazonaws.com/ccos-log.png'}
               id="brandLogo" alt=""/>
        </div>
      </Container>

    </header>
  );
};

export default TopBarSimple;
